export const FORM_CONFIG = "formConfig";
export const PIKETT = "picket";
export const TV_ERSATZTEILE = "tvErsatzteile";
export const FORM_DATA = "formData";
export const NEUTRALISATION = "neutralisation";
export const ADMIN = "admin";
